export const RESPONSE_STATE_ACTION_TYPES = {
  UPDATE_RESPONSE_STATE: 'UPDATE_RESPONSE_STATE',
  RESET_RESPONSE_STATE: 'RESET_RESPONSE_STATE',
};
